import { initExpiryCountdown } from './expiry_countdown';

export const initPasswordRecoveryOtpCountdown = () => initExpiryCountdown({
  timeElementId: 'password-recovery-otp-countdown',
  resendElementId: 'password-recovery-otp-resend',
});
